const colors = {
    red: '#d32f2f',
    lightRed: '#ffcdd2',
    blue: '#115293',
    lightBlue: '#e1f5fe',
    green: '#388e3c',
    lightGreen: '#dcedc8',
    yellow: '#f57c00',
    lightYellow: '#fff9c4',
    gray: '#e0e0e0'
}

export default colors;